// Required Properties
import Backbone from 'backbone';
import $ from 'jquery';
import {getStringRepresentation} from 'model/Person';
import {parseSisDate, parseSisDateTime} from 'util/SisDateTime';
import moment from 'moment';

const PERSON_STRING_REPRESENTATION = 'PersonStringRepresentation';
export const templateModel = new Backbone.Model({templateIndex: localStorage.getItem(PERSON_STRING_REPRESENTATION) || 0});
// optimistic save last value (would not change often, user distinction may not be needed)
templateModel.listenTo(templateModel, 'change:templateIndex', (model, value) => localStorage.setItem(PERSON_STRING_REPRESENTATION, value));
export const PersonAttr = {
	getStringRepresentation: function (p) {
		return getStringRepresentation(p, templateModel.get('templateIndex'));
	},
	getApprovalDateTime: function ({bookingApproval: date, bookingApprovalTime: time} = {}) {
		if (!$.isNumeric(date) || !$.isNumeric(time)) return null;
		// minus eine Millisekunde damit persurl bis zum bisdatum verkürzt werden können
		return moment(parseSisDateTime(date, time).endOf("minute") - 1);
	},
	getBookingEndDateTime: function ({bookingEnd: date} = {}) {
		if (!$.isNumeric(date)) return null;
		// minus eine Millisekunde damit persurl bis zum bisdatum verkürzt werden können
		return moment(parseSisDate(date).endOf('day') - 1);
	},
	getAzeBookingEndDateTime: function ({bookingEndAze: date} = {}) {
		if (!$.isNumeric(date)) return null;
		// minus eine Millisekunde damit persurl bis zum bisdatum verkürzt werden können
		return moment(parseSisDate(date).endOf('day') - 1);
	},
	getLimitDateTime: function (p) {
		return moment.max(this.getApprovalDateTime(p), this.getBookingEndDateTime(p));
	},
};